import { authorizedFetch, authorizedFetchWithoutShareTokens } from './autorizedFetch';

export async function makeRawRestCall(url: RequestInfo, requestConfig?: RequestInit) {
  const response = await authorizedFetch(url, requestConfig);

  return response;
}
export async function makeRestCall(url: RequestInfo, requestConfig?: RequestInit) {
  const response = await authorizedFetch(url, requestConfig);

  let data;
  const clone = response.clone();
  try {
    data = await response.json();
  } catch (error) {
    data = await clone.text();
  }
  return data;
}

export async function makeRestCallWithoutShareTokens(url: RequestInfo, requestConfig?: RequestInit) {
  const response = await authorizedFetchWithoutShareTokens(url, requestConfig);

  let data;
  const clone = response.clone();
  try {
    data = await response.json();
  } catch (error) {
    data = await clone.text();
  }
  return data;
}
